import dayjs from "dayjs";

export const currencyFmt = (value: number | string, currency?: string) => {
  const code = (currency || "EUR").toUpperCase();
  const num = typeof value === "string" ? Number(value || 0) : value || 0;
  return new Intl.NumberFormat("nl-NL", { style: "currency", currency: code }).format(num);
};

export const safeDate = (iso?: string) => (iso ? dayjs(iso).format("DD.MM.YYYY") : "-");
